import type { WorkoutTemplate } from './types.js';

export function workoutProgress(template: WorkoutTemplate, sets: { templateExerciseId: string; setNumber: number }[]) {
  const prescribed = template.exercises.reduce((sum, item) => sum + item.sets, 0);
  const completed = template.exercises.reduce((sum, item) => sum + new Set(sets
    .filter(set => set.templateExerciseId === item.id && set.setNumber >= 1 && set.setNumber <= item.sets)
    .map(set => set.setNumber)).size, 0);
  return { prescribed, completed, percentage: prescribed ? Math.round(completed / prescribed * 100) : 0 };
}

export function calendarStatus(status: string, setCount: number): 'not-started' | 'complete' | 'partial' | 'closed-incomplete' {
  if (status === 'completed') return 'complete';
  if (status === 'abandoned' || status === 'skipped') return 'closed-incomplete';
  return setCount ? 'partial' : 'not-started';
}

export const statusLabels = { 'not-started': 'Not started', complete: 'Complete', partial: 'Partial', 'closed-incomplete': 'Closed incomplete' };
